import React, { FC } from 'react';
import { WithSpacingProps } from 'ia-react-core/~/hocs/grid/withSpacing';
import { MainContentProps } from '../MainContent';

import { StyledContainer, StyledContent } from './MainContentZone.styles';

export interface MainContentZoneProps extends MainContentProps, WithSpacingProps {
  bottomBorder?: string;
  /** @ignore */
  background?: MainContentProps['background'];
  verticalPadding?: MainContentProps['verticalPadding'];
}

const MainContentZoneDefaultProps = {
  background: 'white',
  verticalPadding: 60,
};

/**
 * @mode developer
 */
const MainContentZone: FC<MainContentZoneProps> = ({
  children, nopadding, horizontalPadding, verticalPadding, background, backgroundPosition, backgroundAttachment, backgroundRepeat, backgroundSize, minContentWidth, maxContentWidth, ...props
}) => (
  <StyledContainer {...props}>
    <StyledContent
      nopadding={nopadding}
      horizontalPadding={horizontalPadding}
      verticalPadding={verticalPadding}
      background={background}
      backgroundPosition={backgroundPosition}
      backgroundAttachment={backgroundAttachment}
      backgroundRepeat={backgroundRepeat}
      backgroundSize={backgroundSize}
      minContentWidth={minContentWidth}
      maxContentWidth={maxContentWidth}
    >
      {children}
    </StyledContent>
  </StyledContainer>
);

MainContentZone.defaultProps = MainContentZoneDefaultProps;

export default MainContentZone;
